import { all, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';
import { loginSuccessSaga, logoutSaga, logoutSuccessSaga, sendLoginEventOnceSaga } from './auth';
import { getUserSaga, getUserTagsSaga } from './user';

export function* watchAuth() {
  yield all([
    takeEvery(actionTypes.LOGIN_SUCCESS, loginSuccessSaga),
    takeEvery(actionTypes.GET_USER_SUCCESS, sendLoginEventOnceSaga),
    takeEvery(actionTypes.LOGOUT, logoutSaga),
    takeEvery(actionTypes.LOGOUT_SUCCESS, logoutSuccessSaga),
  ]);
}

export function* watchUser() {
  yield all([
    takeEvery(actionTypes.GET_USER, getUserSaga),
    takeEvery(actionTypes.GET_USER_TAGS, getUserTagsSaga),
  ]);
}
